import { render, staticRenderFns } from "./NoteNode.vue?vue&type=template&id=34eb12d7&"
import script from "./NoteNode.vue?vue&type=script&lang=js&"
export * from "./NoteNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports